const SITE_URL = 'https://baatcheetapp.in';
const DEFAULT_IMAGE = `${SITE_URL}/download-hero.webp`;
const DEFAULT_IMAGE_W = '1448';
const DEFAULT_IMAGE_H = '1086';

// React 19 hoists <title>/<meta>/<link>/<script> rendered anywhere in the tree
// into <head> automatically and de-dupes them — no react-helmet needed.
// Static tags in public/index.html remain as the pre-hydration fallback for
// crawlers/scrapers that don't execute JS; this overrides them per-route once
// the app renders.
//
// jsonLd accepts a single schema object or an array of them (e.g. page schema
// + BreadcrumbList + FAQPage together) — each renders as its own <script>
// tag, which is what Google's Rich Results Test expects rather than a single
// merged @graph for unrelated schema types.
export default function Seo({
  title,
  description,
  path = '/',
  image,
  imageAlt,
  imageWidth,
  imageHeight,
  type = 'website',
  noindex = false,
  jsonLd,
}) {
  const url = `${SITE_URL}${path}`;
  const img = image || DEFAULT_IMAGE;
  const imgW = image ? imageWidth : DEFAULT_IMAGE_W;
  const imgH = image ? imageHeight : DEFAULT_IMAGE_H;
  const alt = imageAlt || title;
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Baatcheet" />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:image:alt" content={alt} />
      {imgW && <meta property="og:image:width" content={String(imgW)} />}
      {imgH && <meta property="og:image:height" content={String(imgH)} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      <meta name="twitter:image:alt" content={alt} />

      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </>
  );
}
